import { Button } from '@mantine/core';
import { CalendarSearch, ChevronLeft, ChevronRight } from 'lucide-react';

import PatientDuplicationPopup from '@/components/AppointmentScheduler/PatientDuplicationPopup.tsx';

import { useChainFooter } from '@/hooks/use-chain-footer.ts';

import { ChainBookingStep } from '@/models/appointment/AppointmentChainConfig.ts';

export const ChainFooterButtons = () => {
    const {
        chainBookingStep,
        cannotProceed,
        cannotBook,
        isBooking,
        isFetching,
        hasSuggestion,
        hasPreviousSuggestion,
        showDuplicationPopup,
        setShowDuplicationPopup,
        handleNext,
        handleAutoSuggest,
        handleNextSuggestion,
        handlePreviousSuggestion,
        handleBack,
        handleBook,
        handleConfirmDuplication,
    } = useChainFooter();

    const isSuggest = chainBookingStep === ChainBookingStep.SUGGEST;
    const isTune = chainBookingStep === ChainBookingStep.TUNE;

    const footerButtons =
        isSuggest || isTune ? (
            <div className="flex w-full items-center justify-between gap-2">
                <Button
                    variant="default"
                    leftSection={<ChevronLeft className="size-4" />}
                    onClick={handleBack}
                    disabled={isBooking}
                >
                    Zurück
                </Button>
                <div className="flex items-center gap-2">
                    {isTune && (
                        <Button
                            variant="default"
                            leftSection={<CalendarSearch className="size-4" />}
                            onClick={handleAutoSuggest}
                            loading={isFetching}
                            disabled={isBooking}
                        >
                            Auto-Vorschlag
                        </Button>
                    )}
                    {isSuggest && hasPreviousSuggestion && (
                        <Button
                            variant="default"
                            leftSection={<ChevronLeft className="size-4" />}
                            onClick={handlePreviousSuggestion}
                            disabled={isFetching || isBooking}
                        >
                            Vorheriger Vorschlag
                        </Button>
                    )}
                    {isSuggest && hasSuggestion && (
                        <Button
                            variant="default"
                            rightSection={<ChevronRight className="size-4" />}
                            onClick={handleNextSuggestion}
                            loading={isFetching}
                            disabled={isBooking}
                        >
                            Nächster Vorschlag
                        </Button>
                    )}
                    <Button
                        rightSection={<ChevronRight className="size-4" />}
                        onClick={handleBook}
                        disabled={cannotBook}
                        loading={isBooking}
                    >
                        Terminkette buchen
                    </Button>
                </div>
            </div>
        ) : (
            <div className="flex w-full justify-between">
                <Button variant="default" leftSection={<ChevronLeft className="size-4" />} disabled>
                    Zurück
                </Button>
                <Button
                    rightSection={<ChevronRight className="size-4" />}
                    onClick={handleNext}
                    disabled={cannotProceed}
                    loading={isFetching}
                >
                    Weiter
                </Button>
            </div>
        );

    return (
        <>
            {footerButtons}
            <PatientDuplicationPopup
                visible={showDuplicationPopup}
                setVisible={setShowDuplicationPopup}
                setConfirm={handleConfirmDuplication}
            />
        </>
    );
};
